import { Component, DestroyRef, inject, input, Input, OnInit, signal } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { LocalizationService, LocalizedNumberFormat } from 'src/app/shared/localization/localization.service';
import { CasesService } from 'src/app/services/cases.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { FormsModule } from '@angular/forms';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MessageToUiService } from 'src/app/services/message-to-ui.service';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-unfounded-debt-case-popup',
    imports: [CommonModule, TranslateModule, MatDialogModule, MatProgressBarModule, FormsModule],
    providers: [DecimalPipe],
    templateUrl: './unfounded-debt-case-popup.component.html',
    styleUrls: ['./unfounded-debt-case-popup.component.scss']
})
export class UnfoundedDebtCasePopupComponent implements OnInit {

    @Input() caseNumber:number;

    #localization = inject(LocalizationService)
    #service = inject(CasesService);
    #dialogRef = inject(MatDialogRef<UnfoundedDebtCasePopupComponent>);
    #notification = inject(MessageToUiService);
    #translateService = inject(TranslateService);
    #decimalPipe = inject(DecimalPipe);
    #destroyRef = inject(DestroyRef);
 
    numberFormat = signal<LocalizedNumberFormat>(null);
    agreementTermsText$:Observable<string>;

    ngOnInit(): void {
        this.#localization.settings$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(settings => this.numberFormat.set(settings.numberPipeFormat));
        this.getUnfoundedDebtCosts();
    }

    acceptAction(): void {

        this.#service.sendUnfoundedDebtCaseRequest(this.caseNumber)
            .pipe(
                takeUntilDestroyed(this.#destroyRef)
            )
            .subscribe({
                next: () => this.#dialogRef?.close(true),
                error: () => this.#notification.genericError()
            });
    }

    cancelAction(): void {
        this.#dialogRef?.close(false);
    }

    private getUnfoundedDebtCosts(): void {

        this.agreementTermsText$ = this.#service.getUnfoundedDebtCost(this.caseNumber)
            .pipe(
                map(_ => {
                    const termsText = `${this.#translateService.instant(
                                        'UnfoundedDebtCaseDialog.UnfoundedDebtCaseInfoMessage',
                                        { 
                                            currency: this.#localization.getFirmCurrencyCode(), 
                                            amount: this.#decimalPipe.transform(_.totalCosts, this.numberFormat().style, this.numberFormat().culture) })
                                        }`;
                    return termsText;
                })
                , 
                catchError(e => {
                    this.errorsNotification();
                    return of('')
                }));

    }

    private errorsNotification() {

        this.#notification.genericError();
        this.cancelAction();
    }
}
